import { ISetSectionContentNodeActionPayload } from '../interfaces/set-section-content-node.action-payload.interface';

export class SetSectionContentNodeId {
    static readonly type = '[Module] SetSectionContentNodeId';

    constructor(public payload: ISetSectionContentNodeActionPayload) {}
}
